<template>
  <div class="float" @mouseleave="hoverFloat = false" v-if="isWithinWorkingHours(new Date())">
    <!--  @mouseleave="hoverFloat = false" -->
    <transition name="fade">
      <div class="floatHref" v-show="hoverFloat">
        <img style="width: 100px;height: 100px;" src="@/assets/images/technicalSupport.png" />
        <!-- <div class="HrefTxt">
          <a href="https://www.xinnet.com/online-service.html" target="_blank">
            <p class="f-size14">在线咨询</p>
            <span>售后问题人工解答，精准解答及帮您反馈</span>
          </a>
        </div>
        <div class="HrefTxt">
          <a href="http://zn269766ocklg09g.mikecrm.com/zcbzJEt" target="_blank">
            <p class="f-size14">建议反馈</p>
            <span>新网不是完美的，我们渴望您的建议</span>
          </a>
        </div> -->
      </div>
    </transition>
  </div>
</template>
<script setup lang="ts">
import { ref,onMounted   } from 'vue'
const hoverFloat = ref(false)

const isWithinWorkingHours = (date) => {
      const day = date.getDay(); // 0 表示星期天，1 到 6 表示工作日
      const hours = date.getHours();
      const minutes = date.getMinutes();
 
      // 判断是否为工作日
      if (day === 0 || day === 6) {
        return false;
      }
      // const  hours = 14
      // const minutes = 50
      // 判断时间是否在 9:00 至 17:45 之间
      const isWithinHours = hours >= 9 && hours <= 16;
      const isWithinMinutes = minutes <= 45;

      return hours >= 9 && hours < 17 || (hours === 17 && isWithinMinutes)
    };

    onMounted(() => {
      // 创建一个script元素来加载外部聊天机器人脚本
      const script = document.createElement('script');
      script.src = 'https://chatbot.xinnet.com/embed.min.js';
      script.id = 'dify-chatbot-script';
      script.defer = true;
      
      // 将script元素添加到文档的head中
      document.head.appendChild(script);

      // 设置聊天机器人的配置
      window.difyChatbotConfig = {
        token: 'hIjmkZWTgOCuBz7z',
        baseUrl: 'https://chatbot.xinnet.com'
      };
    });


</script>
<style lang="scss" scoped>
.float {
  position: fixed;
  right: 20px;
  bottom: 50px;
  z-index: 1000;
  width: 53px;
  height: 154px;
  .f-size14{
    font-size: 14px;
    font-weight: 600;
  }
  .floatFixed {
    position: absolute;
    right: 0;
    bottom: 0;
    text-align: center;
    background: linear-gradient(200deg,#29acfe,#2468f2 89%);
    // height: 148px;
    width: 40px;
    box-shadow: 0px 0px 8px 0px rgba(25,15,15,0.07), 0px 0px 16px 0px rgba(0,0,0,0.03);
    border-radius: 20px;
    cursor: pointer;
    color: rgba(0,0,0,0.85);
    font-size: 14px;
    padding: 10px;
    line-height: 21px;
    // background: #333333;
    color: #fff;

  }
  // .floatFixed:hover {
  //   background: #333333;
  //   color: #fff;
  // }
  .floatHref {
    right: 50px;
    position: absolute;
    bottom: 0px;
    background: linear-gradient( 180deg, #FFFFFF 0%, #FFFFFF 100%);
    padding: 12px;
    border-radius: 6px;
    // width: 280px;
    width: 125px;
    box-shadow: 0px 2px 40px -12px rgba(108,111,125,0.3), 0px 2px 6px 0px rgba(212,222,233,0.31);
    div {
      padding: 16px;
      a {
        text-decoration: none;
      }
      p {
        color: rgba(0,0,0,0.85);
        line-height: 26px;
        margin: 0;
      }
      span {
        font-size: 12px;
        color: rgba(0,0,0,0.45);
      }
    }
    .HrefTxt:hover {
      background: rgba(0,0,0,0.03);
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>